<div class="mode"[ngClass]="dark ? 'active' : '' " (click)="layoutToggle()">
    <app-feathericon [icon]="'moon'"></app-feathericon>
</div>